import React from 'react'
import { Stack, Typography } from '@mui/material'
import { formatPercentage } from '../../packages/utils/numberFormatters'

function feeLevelName(fees, feeLevel) {
    const isTopDown = !!fees.find((f) => f.feeLevel === feeLevel)?.topDown
    const topDown = isTopDown ? ' (topdown)' : ''
    if (!fees.some((f) => f.feeLevel > 1)) {
        return 'garantiåtagare' + topDown
    }
    if (!fees.some((f) => f.feeLevel > 2)) {
        return feeLevel === 1 ? 'bottengaranti' + topDown : 'toppgaranti' + topDown
    }
    return `garantinivå ${feeLevel}` + topDown
}

/**
 * Describes the actual fee, percentage, cash or shares based.
 */
function feeDescription(fee) {
    const percent = (p) => formatPercentage(p, { locale: 'sv', minDecimals: 0, maxDecimals: 1 })
    if (fee.feeCash && fee.feeUnits) {
        return `${percent(fee.feeCash)} kontant ${fee.feeBoth ? 'och' : 'eller'} ${percent(
            fee.feeUnits,
        )} i aktier/units.`
    }
    if (fee.feeCash) {
        return `${percent(fee.feeCash)} kontant.`
    }
    if (fee.feeUnits) {
        return `${percent(fee.feeUnits)} i aktier/units.`
    }
    return 'Ingen ersättning utgår.'
}

function FeesInformation({ issue }) {
    let fees = issue.fees
    if (!fees || fees.length === 0 || !fees.some((fee) => fee.feeLevel > 0)) return null
    fees = fees.filter((fee) => fee.feeLevel > 0).sort((a, b) => (a.feeLevel > b.feeLevel ? 1 : -1))
    return (
        <Stack spacing={2} direction='column'>
            {fees.map((fee) => (
                <Typography key={fee.id}>
                    Ersättningsnivå för {feeLevelName(fees, fee.feeLevel)}: {feeDescription(fee)}
                </Typography>
            ))}
        </Stack>
    )
}

export { FeesInformation, feeLevelName }
